<template>
  <v-btn-form :title="title" @close="cancel()" listable>
      <v-list one-line dense>
        <v-list-tile >
         <v-list-tile-content>
          </v-list-tile-content>
          <v-list-tile-action>   
            <div>
              <v-icon @click="clear">check_box_outline_blank</v-icon>           
              <v-icon @click="checkAll">check_box</v-icon>           
              <!-- <v-icon @click="checkAll">add_box</v-icon>            -->
              <v-icon v-show="removeMode" @click="minusAll">indeterminate_check_box</v-icon>
            </div>
          </v-list-tile-action>
        </v-list-tile>
        <template v-for="item in this.items">
          <v-list-tile v-bind:key="item.id" @click="select(item.id)">
           <v-list-tile-content>
              <v-list-tile-title ><span @click.stop="open(item)">{{item.name}}</span></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>   
              <v-icon v-show="check(item.id)">check_box</v-icon>           
              <v-icon v-show="!check(item.id) && !check(-1 * item.id)">check_box_outline_blank</v-icon>
              <v-icon v-show="check(-1 * item.id)">indeterminate_check_box</v-icon>           
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    <template #actions>
      <v-btn @click="ok">ОК</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="addItem()">Добавить</v-btn>
      <!-- <v-btn @click="clear">Очистить</v-btn> -->
    </template>
  </v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import dialogs from '../common/dialogs'
  import vBtnForm from '../common/BtnForm'
  import vTagForm from './TagForm.vue'

  export default {
    name: 'tag-selector',
    components: {vBtnForm},
    data: () => ({
      isLoading: false,
      itemId: null,
      selectedIds: []
    }),
    created () {
      this.fetchItems()
      if (this.selected != null) {
        this.selectedIds = this.selected.map(t => Number.parseInt(t))
      }
    },
    mounted () {
    },
    watch: {
    },
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      selected: {
        type: Array,
        default: null
      },
      removeMode: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters({
        calcDialogScroll: 'calcDialogScroll',
        getTags: 'getTags'
      }),
      title () {
        return 'Выберите метки'
      },
      items () {
        return this.getTags
      }
    },
    methods: {
      ok () {
        this.$emit('input', this.selectedIds)
        this.cancel()
      },
      cancel () {
        this.$emit('close')
        this.itemId = null
      },
      select (uid) {
        if (this.removeMode) {
          if (!this.check(uid)) {
            if (!this.check(-1 * uid)) {
              this.selectedIds.push(uid)
            } else {
              this.selectedIds = this.selectedIds.filter(i => i !== -1 * uid)
            }
          } else {
            this.selectedIds = this.selectedIds.filter(i => i !== uid)
            this.selectedIds.push(-1 * uid)
          }
        } else {
          if (!this.check(uid)) {
            this.selectedIds.push(uid)
          } else {
            this.selectedIds = this.selectedIds.filter(i => i !== uid)
          }
        }
      },
      clear () {
        this.selectedIds = []
      },
      checkAll () {
        this.selectedIds = this.items.map(i => i.id)
      },
      minusAll () {
        this.selectedIds = this.items.map(i => -1 * i.id)
      },
      open (item) {
        this.dialogOpen(item)
      },
      check (uid) {
        return this.selectedIds.includes(uid)
      },
      addItem () {
        this.dialogOpen(null)
      },
      fetchItems (force) {
        this.$store.dispatch('fetchTags', force)
      },
      dialogOpen (item) {
        var self = this
        const setNotes = function (data) {
          self.fetchItems(true)
        }

        dialogs.register('v-tag-form', vTagForm)
        var comp = { template: `
          <v-tag-form :itemId="itemId" :model="model" :fullscreen="fullscreen" v-on:close="$emit('close')" v-on:refresh="setNotes"></v-tag-form>
          `,
          data () {
            return {
              itemId: item !== null ? item.id : null,
              fullscreen: self.fullscreen,
              model: item,
              setNotes: setNotes
            }
          }
        }
        dialogs.modal(comp)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// TagSelector.vue?9437eaec